import DataIngestionView from './DataIngestion.View';

export default DataIngestionView;
